/* What a day's all-day entries say, in one shape.
 *
 * The server sends a LIST — Christmas Day, annual leave, a conference — and
 * every screen was written against a single object with `label` and
 * `blocked`. Reading a list as that object finds neither, so a public holiday
 * never appeared and the "you are away" banner could never render. Every
 * screen reads through here now, whichever shape arrives.
 */

import type { DayContext, DayContextEntry } from '@shared/types';

export interface ReadContext {
  /** Every entry's title, joined — what to print above the day. */
  label: string | null;
  /** The person's own calendar says they are away. */
  blocked: boolean;
  /** The entry that says so, in their words. */
  reason: string | null;
  entries: DayContextEntry[];
}

export function readContext(ctx: DayContext | DayContextEntry[] | null | undefined): ReadContext {
  if (Array.isArray(ctx)) {
    const busy = ctx.find(e => e.busy);
    return {
      label: ctx.length ? ctx.map(e => e.title).join(' · ') : null,
      blocked: !!busy,
      reason: busy?.title ?? null,
      entries: ctx
    };
  }
  if (ctx && typeof ctx === 'object') {
    return {
      label: ctx.label ?? null, blocked: !!ctx.blocked, reason: ctx.reason ?? null,
      entries: ctx.label ? [{ title: ctx.label, busy: !!ctx.blocked }] : []
    };
  }
  return { label: null, blocked: false, reason: null, entries: [] };
}
